<template>

<div class="body">
    <!-- <div class='bg-text'>0 0 7</div> -->
    <div class="login">
        <form class="loginInfo">
            <div>
                <img class="login-logo" src="../../assets/logo_rectangle.png" />
            </div>
            <div class="email">
                <el-input v-model="where.email" @keyup.enter.native="onSubmit" autofocus placeholder="Email"/>
            </div>
            <div class="pwd">
                <el-input type="password" @keyup.enter.native="onSubmit" v-model="where.password" placeholder="Password"/>
            </div>
            <div class="btn">
                <el-button @click="onSubmit" class="loginBtn">LOGIN</el-button>
            </div>
        </form>
    </div>
    <div class="bg-img">
        <img src="../../assets/channel_login_background.jpeg" />
    </div>
</div>
</template>

<script>
import { post } from "@/lib/channelClient";
export default {
	name: "app",
	data() {
		return {
			where: {
				email: "",
				password: "",
				api_token: "",
			},
		};
	},
	mounted() {
		const uri = window.location.search.substring(1);
		const params = new URLSearchParams(uri);
		this.where.api_token = params.get("api_token");
		if (this.where.api_token) {
			this.onSubmit();
		}
	},
	methods: {
		async onSubmit() {
			const res = await post("/channelClient/login", this.where);
			if (res.status !== 200) {
				const text = await res.text();
				this.$message.error({ message: text, duration: 1500 });
				return;
			}
			const body = await res.json();
			localStorage.setItem("channel_email", body.email);
			localStorage.setItem("api_url", body.api_url);
			window.location.href = "./report";
		},
	},
	components: {},
};
</script>


<style>
.login-input > input {
    border: none;
    border-bottom: 1px solid #000;
    border-radius: unset;
}
.login-input > input:-webkit-autofill{
box-shadow: 0 0 0px 1000px #fff inset;
}
.login-input > input:focus {   
	border:none;
}
</style>

<style scoped>
.body {
    display: flex;
    width: 100%;
    align-items: center;
    /* background: url(../../assets/channel_login_background.jpeg) repeat; */
    background-size: 100% 100%;
    position: relative;
}
.login {
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
}
.login-logo {
  width: 300px;
}
.loginInfo {
    display: flex;
    width: 50%;
    height: 90%;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.loginInfo > div {
    margin-bottom: 20px;
}
.email,
.pwd {
    display: flex;
    width: 365px;
    padding-bottom: 20px;
}
.btn {
    text-align: right;
    width: 365px;
}
.loginBtn {
    height: 35px;
    /* background-color: #020202; */
    width: 180px;
    color: #3fc5f4;
}
.footer {
    width: 100%;
    height: 40px;
    background-color: #f2f2f2;
    margin-top: 80px;
    text-align: center;
    font-size: 12px;
    line-height: 40px;
    border-radius: 10px;
}
.bg-text{
    width: 100%;
    height: 100%;
    color:#ffffff;
    font-size:600px;
    text-align: center;
}
.bg-img{
    position: absolute;
    left: 0;
    bottom: 0;
    img {
        max-width: 600px;
    }
}
</style>